export enum SSOLoginStatus {
  NotFound = 'notFound',
  Unauthorized = 'unauthorized',
}

export enum SSOErrorMessage {
  NotFound = 'Sorry, You are not registered in this application.',
  Unauthorized = 'Sorry, You are not allowed to access this application.',
}
